import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileService } from '@core/services/api/file.service';



@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [FileService]
})
export class CoreModule { }
